const apiUrl = process.env.REACT_APP_API_URL;
export const PostEscoles = async ( id : number | null, nom : string, comentaris : string, id_loop : string, menjador : boolean, extraescolars : boolean, casals : boolean, referent : string, proposta : boolean, menu : number, page : string, idUsuLog : string ) => {
    try {
        const response = await fetch(`${apiUrl}:8071/escoles/${idUsuLog}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            },
            body: JSON.stringify({id, nom, comentaris, id_loop, menjador, extraescolars, casals, referent, proposta, menu})
        });
        if (!response.ok) {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};